export default __webpack_public_path__ + "static/media/staging-shutdown-tab.0e38db49.png";